import { useToast } from '@lego/klik-ui';
import { type IDetectedBarcode, Scanner } from '@yudiel/react-qr-scanner';
import { ToastOptions } from '@/utility/ToastOptions';
import { ToastFactory } from '@/utility/toast_factory';

export type DeviceScan =
  | {
      isManual: false;
      vendor?: string;
      model?: string;
      serialNumber: string;
      macAddresses: string[];
      raw: string;
    }
  | {
      isManual: true;
      vendor?: string;
      model?: string;
      serialNumber: string;
      macAddresses: [];
      raw: string;
    };

type QrScannerProps = {
  onScan: (result: DeviceScan) => void;
};

export const QrScanner = ({ onScan }: QrScannerProps) => {
  const toast = useToast();
  const handleScan = (result: string) => {
    try {
      const scannedPayload = result.trimStart();
      const version = scannedPayload[0];
      switch (version) {
        case '2': {
          const delimiter = scannedPayload[1];
          const [, vendor, model, serialNumber, ...macAddresses] = result.split(delimiter);
          onScan({
            macAddresses: macAddresses.map((mac) => mac.replaceAll(':', '')),
            raw: result,
            vendor: vendor,
            model: model,
            serialNumber,
            isManual: false,
          });
          break;
        }
        case '1': {
          const [, serialNumber, ...macAddresses] = result.split(',');
          onScan({
            macAddresses: macAddresses.map((mac) => mac.replaceAll(':', '')),
            raw: result,
            serialNumber,
            isManual: false,
          });
          break;
        }
        default:
          toast(ToastOptions.error('Invalid QR Code', 'We were unable to parse the QR code'));
      }
    } catch (error) {
      toast(ToastFactory.fromError(error));
    }
  };
  return (
    <Scanner
      constraints={{
        facingMode: 'environment',
        height: { ideal: 720, max: 1080, min: 240 },
        width: { ideal: 720, max: 1920, min: 320 },
      }}
      onScan={(result: IDetectedBarcode[]) => {
        handleScan(result[0].rawValue);
      }}
    />
  );
};
